/**
 * @file DeliveryBlockCta.tsx
 * @description Вторичные кнопки блока «Доставка»: «Изменить условия доставки»
 * и «Согласовать доставку» (phase19.24 шаг 5.2, ревью 5.2).
 *
 * Обе кнопки открывают путь к правке условий, но разными способами: первая
 * предупреждает клиента новым письмом (F30), вторая переводит заказ со стадии
 * «Заявка» в согласование — без перехода сервер правку не примет.
 *
 * Какую показать, решает запись реестра (`change` / `agree`), а не условие в
 * разметке: инвариант «кнопки не бывает там, где сервер откажет» держится в
 * одном месте — `delivery-block-state.ts`.
 */

import { Handshake } from "lucide-react";

import type { DeliveryBlockStateMeta } from "../../../lib/delivery-block-state";
import { Button } from "../../ui/button";

interface Props {
  meta: DeliveryBlockStateMeta;
  disabled: boolean;
  /** Открыть окно «условия уже видел клиент» и после него — форму. */
  onChange: () => void;
  /** Перевести заказ в стадию согласования доставки (`agreeDelivery`). */
  onAgree?: () => void;
}

export function DeliveryBlockCta({ meta, disabled, onChange, onAgree }: Props) {
  if (meta.change) {
    return (
      <Button
        variant="outline"
        className="min-h-14 self-start lg:min-h-12"
        disabled={disabled}
        onClick={onChange}
      >
        Изменить условия доставки
      </Button>
    );
  }
  if (!meta.agree || !onAgree) return null;
  return (
    <Button
      className="min-h-14 self-start lg:min-h-12"
      disabled={disabled}
      onClick={onAgree}
    >
      <Handshake className="mr-1 size-4" aria-hidden />
      Согласовать доставку
    </Button>
  );
}
